import React, { forwardRef } from 'react'
import { Box, Alert, Typography, SxProps, Theme } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-duotone-svg-icons/faCircleExclamation'
import { faInfo } from '@fortawesome/pro-duotone-svg-icons/faInfo'
import { faWarning } from '@fortawesome/pro-duotone-svg-icons/faWarning'
interface EmptyStateProps {
    message: string
    variant?: 'info' | 'warning' | 'error'
    sx?: SxProps<Theme>
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
    ({ message, variant = 'info', sx }, ref) => {
        const iconMap = {
            info: <FontAwesomeIcon icon={faInfo} />,
            warning: <FontAwesomeIcon icon={faWarning} />,
            error: <FontAwesomeIcon icon={faCircleExclamation} />,
        }

        return (
            <Box ref={ref} sx={{ p: 1, ...sx }}>
                <Alert severity={variant} icon={iconMap[variant]}>
                    <Typography variant="body2">{message}</Typography>
                </Alert>
            </Box>
        )
    }
)

EmptyState.displayName = 'EmptyState'
